
import React, { useState, useEffect, useRef } from 'react';
import { CSVLink } from 'react-csv';
import { exportToPDF, printTableFromHtml, generateCSVData } from '../../services/exportService';
import apiService from '../../services/apiService';

const UserReportView = () => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [deviceId, setDeviceId] = useState('');
  const [filterId, setFilterId] = useState('1'); // Default "All"

  const [reportData, setReportData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [summary, setSummary] = useState({
    totalCardCount: 0,
    totalCardListingMinutes: 0,
    totalRadioListingMinutes: 0,
    totalSleepListingMinutes: 0,
  });

  const tableRef = useRef(null);

  useEffect(() => {
    fetchReportData(); 
  }, [filterId]); 
  
  useEffect(() => {
    applyFilter();
  }, [reportData, mobileNumber, deviceId]);

  const fetchReportData = async () => {
    try {
      const payload = { date_range: parseInt(filterId) };
      const response = await apiService.postData("admin/user-report", payload);
  
      if (!response.error && response.data) {
        const formattedData = response.data.map((item) => ({
          user_id: item.user_id,
          mobile: item.mobile || '',
          deviceId: item.deviceId || '',
          totalCards: item.totalCards || 0,
          card_listing: Math.round((item.cardlisteningTimeSeconds || 0) / 60),
          radio_listing: Math.round((item.radioListeningTimeSeconds || 0) / 60),
          sleep_listing: Math.round((item.sleepListeningTimeSeconds || 0) / 60),
        }));
  
        setReportData(formattedData);
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
    }
  };
  
  const applyFilter = () => {
    let filtered = [...reportData];

    if (mobileNumber.trim()) {
      filtered = filtered.filter(d => d.mobile.includes(mobileNumber.trim()));
    }

    if (deviceId.trim()) {
      filtered = filtered.filter(d => d.deviceId.includes(deviceId.trim()));
    }

    setFilteredData(filtered);

    const totalCardCount = filtered.reduce((sum, item) => sum + (item.totalCards || 0), 0);
    const totalCardListingMinutes = filtered.reduce((sum, item) => sum + (item.card_listing || 0), 0);
    const totalRadioListingMinutes = filtered.reduce((sum, item) => sum + (item.radio_listing || 0), 0);
    const totalSleepListingMinutes = filtered.reduce((sum, item) => sum + (item.sleep_listing || 0), 0);

    setSummary({
      totalCardCount,
      totalCardListingMinutes,
      totalRadioListingMinutes,
      totalSleepListingMinutes,
    });
  };

  const columns = [
    '#',
    'Mobile',
    'Device ID',
    'Total Card Count',
    'Card Listing Time (Min)',
    'Radio Listing Time (Min)',
    'Sleep Listing Time (Min)',
  ];

  const data = filteredData.map((item, i) => [
    i + 1,
    item.mobile,
    item.deviceId,
    item.totalCards,
    item.card_listing,
    item.radio_listing,
    item.sleep_listing,
  ]);

  const handleExportPDF = () => {
    exportToPDF('User Usage Report', columns, data, 'UserUsageReport.pdf');
  };

  const handlePrint = () => {
    if (tableRef.current) {
      printTableFromHtml(tableRef.current.innerHTML, 'User Usage Report');
    }
  };

  return (
    <div className="container mt-4">
      <div className="card p-3">

        {/* Filters */}
        <div className="mb-3 d-flex gap-3 align-items-center">
  <input
    type="text"
    placeholder="Filter by Mobile Number"
    value={mobileNumber}
    onChange={e => setMobileNumber(e.target.value)}
    className="form-control"
  />
  <input
    type="text"
    placeholder="Filter by Device ID"
    value={deviceId}
    onChange={e => setDeviceId(e.target.value)}
    className="form-control"
  />
  <select
    value={filterId}
    onChange={e => setFilterId(e.target.value)}
    className="form-select"
    style={{ maxWidth: '180px' }}
  >
    <option value="1">All</option>
    <option value="2">Today</option>
    <option value="3">Yesterday</option>
    <option value="4">Last Week</option>
  </select>
</div>

        {/* Export Buttons */}
        <div className="card-header d-flex justify-content-between align-items-center mb-3 px-0 border-0">
          <h3 className="mb-0">User Report</h3>
          <div className="d-flex gap-2">
            <button className="btn btn-outline-danger" onClick={handleExportPDF}>
              Export PDF
            </button>
            <CSVLink
              filename="UserUsageReport.csv"
              className="btn btn-outline-success"
              data={generateCSVData(columns, data)}
            >
              Export CSV
            </CSVLink>
            <button className="btn btn-outline-secondary" onClick={handlePrint}>
              Print
            </button>
          </div>
        </div>

        {/* Summary */}
        {/* <div className="row mb-4">
          {[
            { label: "Total Card Count", value: summary.totalCardCount },
            {
              label: "Total Card Listing Time",
              value: `${summary.totalCardListingMinutes} mins (${(summary.totalCardListingMinutes / 60).toFixed(2)} hrs)`
            },
            {
              label: "Total Radio Listening Time",
              value: `${summary.totalRadioListingMinutes} mins (${(summary.totalRadioListingMinutes / 60).toFixed(2)} hrs)`
            },
            {
              label: "Total Sleep Listening Time",
              value: `${summary.totalSleepListingMinutes} mins (${(summary.totalSleepListingMinutes / 60).toFixed(2)} hrs)`
            }
          ].map((item, idx) => (
            <div className="col" key={idx}>
              <div className="p-3 bg-light border rounded text-center">
                <div className="fw-bold">{item.label}</div>
                <div>{item.value}</div>
              </div>
            </div>
          ))}
        </div> */}

        {/* Table */}
        <div className="table-responsive" ref={tableRef}>
          <table className="table table-bordered mb-0">
            <thead className="table-light">
              <tr>
                {columns.map((col, i) => (
                  <th key={i} className="text-center">{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item, i) => (
                  <tr key={i}>
                    <td className="text-center">{i + 1}</td>
                    <td className="text-center">
                      <a
                        href={`report/user/view/${item.user_id}`}
                        className="text-primary text-decoration-underline"
                      >
                        {item.mobile || '-'}
                      </a>
                    </td>
                    <td className="text-center">{item.deviceId || '-'}</td>
                    <td className="text-center">{item.totalCards ?? '-'}</td>
                    <td className="text-center">{item.card_listing ?? '-'}</td>
                    <td className="text-center">{item.radio_listing ?? '-'}</td>
                    <td className="text-center">{item.sleep_listing ?? '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="text-center py-3">No data found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>
  );
};

export default UserReportView;